<script>
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
  import Helper from './components/Helper.svelte';
  import { viewsXpages, registerXpage } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado  
  import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 

	import Alert from './componentes/Alert.svelte';
	import Input from './componentes/Forms/Input.svelte';
  import Modal from './components/Modal.svelte';
  import { fade, fly } from 'svelte/transition';  import { push } from 'svelte-spa-router';
  import AnimationContainer from './components/AnimationContainer.svelte';
  import Navbar from './components/Navbar.svelte';
  import Titlesection from "./components/Titlesection.svelte";
  import { autentificado, prefix, urlapi, login,miPermiso,iduser,sucursal,sucursalStore } from './stores/store';

  import DatagridRow from './componentes/DatagridRow.svelte';
  import DatagridTitle from './componentes/DatagridTitle.svelte';
  import DatagridCell from './componentes/DatagridCell.svelte';
  import Datagrid from './componentes/Datagrid.svelte';

  import Infopagination from './components/Infopagination.svelte';
  import Pagination from './components/Pagination.svelte';
  import Searchsection from "./components/Searchsection.svelte";
  import { number_format, object2array, postData } from './scripts';

  import moment from 'moment';

  const res=null;

  export let params = {}

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if( $miPermiso.productos.kardex===false ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */


  let uid=null; // CAMBIO AGREGAR VARIABLE  

  let id=params.id;
  let idproducto=false;
  let nombre='';
  let error_producto=false;

  let datagrid=[]
  let cargando=false;
  let pageActual=0;
  let dataPagination={};
  let searchText='';
  let orderField='id';
  let orderDir='DESC';

  let avanzado=false;
  let origen='0';
  let destino='0';
  let tipo='0';
  let desde='00-00-0000';
  let hasta='00-00-0000';
  let existencias={};

  let sucursales=[{0:'Sin filtrar'}];
  Object.keys($sucursalStore).map(function(value) { sucursales=[...sucursales,{[value] :$sucursalStore[value]}] });  
    
  function eventPage(event)
  {
      pageActual=event.detail.text;
      loadData()
  }

  function eventSearch(event)
  {
      pageActual=0;
      searchText=event.detail.text
      loadData()
  }

  function eventText()
  {
      pageActual=0;
      loadData()
  }

  async function loadData()
  {
        cargando=true;

        const res1 = await postData($urlapi, [{'cmd': "productos_getProductoID",codigo:id}])
        .then(data => {
            if(data[0].result===false)
            {
                error_producto=true;
            } else {
                nombre=data[0].result.descripcion
                idproducto=data[0].result.id
                existencias=data[0].result
                delete existencias.descripcion;
                delete existencias.id;
                delete existencias.codigo;
                
                let datos={ 
                    'cmd': "movimientos_kardex",
                    sucursal: $sucursal,
                    pagination: $viewsXpages,
                    page: pageActual,
                    order: orderField,
                    codigo:id,
                    dir: orderDir }

                if(avanzado===true)
                {
                    if(searchText!='') datos={...datos, 'search':searchText }
                    if(tipo!=='0') datos={...datos, 'tipo':tipo }
                    if(origen!=='0') datos={...datos, 'origen':origen }
                    if(destino!=='0') datos={...datos, 'destino':destino }
                    if(desde!=='00-00-0000' && desde!=='') datos={...datos, 'desde':desde }
                    if(hasta!=='00-00-0000' && hasta!=='') datos={...datos, 'hasta':hasta }
                }
            
                const res2 = postData($urlapi, [datos])
                .then(data => {
                    datagrid= object2array(data[0].result);
                    dataPagination=data[0].pagination;
                    cargando=false;
                });

            }
        });

  }

  let edit= function(id) { push('/productos/'+idproducto); }
  let function_salir= function() { console.log('salir');push('/productos'); }


  function orderTable(event) {
        if(cargando===false) {
        pageActual=0;
        orderField=event.detail.order;
        orderDir=event.detail.dir;
        loadData()
        }
  }
  

  let helper=false;

  let seleccionado=false;
  let selected= function (event) { 
      if(seleccionado==false || seleccionado!==event.detail.id) {
        seleccionado=event.detail.id
      } else {
        seleccionado=false
      }
  }

  let disableEventData=false;

</script>

{#if viewPage}
<Navbar />

<AnimationContainer>

  <Titlesection>
      <span slot="title"><i class="bi bi-file-earmark-spreadsheet me-1" />Kardex <strong>{nombre}</strong> <small>[Código: {id}]</small></span>
      <span slot="toolbar">
        <!-- <button class='btn btn-warning' on:click={()=>edit(id)} on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}><i class="bi bi-pencil-square"></i></button> -->

        <button class='btn btn-warning btn-sm' on:click={function_salir} on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}><i class="bi bi-box-arrow-left"></i></button>

        {#if avanzado===false}
        <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
        {:else}
        <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
        {/if}

        <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>
     
        <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
    </span>

  </Titlesection>

  {#if error_producto===true}
    <div class='mt-3 mb-3'>
        <Alert disableMarginBottom animation={false}>EL PRODUCTO NO EXISTE</Alert>
    </div>
  {:else}

        <!-- <div class="container-fluid mt-2">
            <div class="row">
                <div class="col-12">
                    <h1 class='text-secondary'><i class="bi bi-box-seam me-1 float-start me-2"></i></h1>
                    <h3 class='text-primary mb-0'>{nombre}</h3>
                    <h6 class='text-primary'>[Código: {id}]</h6>
                </div>
            </div>
        </div> -->


        {#if avanzado===true}
            <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
                <div class="row">
                    <div class='col-12 mb-2 mt-2'>
                        <Input label='Filtrar por ID' bind:value={searchText} on:change={eventText} />
                    </div>                     
                    <div class='col-12 col-md-4 col-lg-4 mb-2'>
                        <Input label='Origen' bind:value={origen} tipo='select' on:change={eventSearch} datos={sucursales} />
                    </div>
                    <div class='col-12 col-md-4 col-lg-4 mb-2'>
                        <Input label='Destino' bind:value={destino} tipo='select' on:change={eventSearch} datos={sucursales} />
                    </div>
                    <div class='col-12 col-md-4 col-lg-4 mb-2'>
                        <Input label='Tipo' bind:value={tipo} tipo='select' on:change={eventSearch} datos={[{'0':'Sin Filtrar'},{'I':'INGRESO'},{'S':'SALIDA'},{'T':'TRASLADO'},{'F':'FACTURA'},{'AI':'ANULACIÓN INGRESO'},{'AS':'ANULACIÓN SALIDA'},{'AT':'ANULACIÓN TRASLADO'},{'AF':'ANULACIÓN FACTURA'}]} />
                    </div>

                    <div class='col-12 col-md-8 col-lg-4 mb-2'>
                    <Input label='Fecha' bind:value={desde} bind:value2={hasta} tipo='range' on:change={eventSearch} />
                    </div>
                </div>
            </div>
        {/if}

        <!-- DATA GRID -->
        <div class="container-fluid mt-2">
            <div class="row">
                <div class="col-12">
                    <Datagrid bind:uid={uid} order={orderField} dir={orderDir} on:order={orderTable} hideCheckbox={true}>

                        <svelte:fragment slot="botonera">
                            <!-- <button class='btn btn-warning' on:click={()=>edit(id)} on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}><i class="bi bi-pencil-square"></i></button> -->

                            {#if avanzado===false}
                                <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
                            {:else}
                                <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
                            {/if}


                        </svelte:fragment>

                        <svelte:fragment slot="header">
                            <DatagridTitle width='100px' order="id" title='ID'  class='pe-2' align='right'/>
                            <DatagridTitle width='200px' order="fecha" title='Fecha'/>
                            <DatagridTitle order="tipo" title='Tipo'/>
                            <DatagridTitle title='Cantidad' class='pe-2' align='right'/>
                            <DatagridTitle order="origen" title='Origen'/>
                            <DatagridTitle title='Exist. Origen' align='right' class='pe-2'/>
                            <DatagridTitle order="destino" title='Destino'/>
                            <DatagridTitle title='Exist. Destino' align='right' class='pe-2'/>
                        </svelte:fragment>
                        <svelte:fragment slot="body">
                        {#each datagrid as item}
                        <DatagridRow id={item.id} bind:seleccionado={seleccionado} hideCheckbox={true}>
                                <DatagridCell title='ID' class='pe-2' align='right'>{item.id}</DatagridCell>
                                <DatagridCell title='Fecha'>{moment(item.fecha).format('DD/MM/YYYY, HH:mm:ss')}</DatagridCell>
                                <DatagridCell title='Tipo'>
                                    {#if item.tipo=='I'}
                                        <span class='text-success'><i class="bi bi-arrow-left me-1"></i>Ingreso</span>
                                    {:else if item.tipo=='AI'}
                                        <span class='text-success'><i class="bi bi-arrow-left me-1"></i>Anulación Ingreso</span>
                                    {:else if item.tipo=='S'}
                                        <span class='text-danger'><i class="bi bi-arrow-right me-1"></i>Salida</span>
                                    {:else if item.tipo=='AS'}
                                        <span class='text-danger'><i class="bi bi-arrow-right me-1"></i>Anulación Salida</span>
                                    {:else if item.tipo=='T'}
                                        <span class='text-primary'><i class="bi bi-arrow-left-right me-1"></i>Traslado</span>
                                    {:else if item.tipo=='AT'}
                                        <span class='text-primary'><i class="bi bi-arrow-left-right me-1"></i>Anulación Traslado</span>                                
                                    {:else if item.tipo=='F'}
                                        <span class='text-warning'><i class="bi bi-arrow-left-right me-1"></i>Factura</span>
                                    {:else if item.tipo=='AF'}
                                        <span class='text-warning'><i class="bi bi-arrow-left-right me-1"></i>Anulación Factura</span>
                                    {/if}
                                </DatagridCell>
                                <DatagridCell title='Cantidad' class='pe-2' align='right'>{item.cantidad}</DatagridCell>                                
                                <DatagridCell title='Origen'>
                                    {#if $sucursalStore[item.origen] === undefined}
                                        <small class="text-secondary">No aplica</small>
                                    {:else}
                                        <span class="badge bg-secondary">{item.origen}</span> {$sucursalStore[item.origen]}
                                    {/if}
                                </DatagridCell>
                                <DatagridCell title='Exist. Origen' align='right' class='pe-2'>
                                    {#if item.existOrig===null}
                                        <small class="text-secondary">No aplica</small>
                                    {:else}
                                        {item.existOrig}
                                    {/if}                            
                                </DatagridCell>
                                <DatagridCell title='Destino'>
                                    {#if $sucursalStore[item.destino] === undefined}
                                        <small class="text-secondary">No aplica</small>
                                    {:else}
                                        <span class="badge bg-secondary">{item.destino}</span> {$sucursalStore[item.destino]}
                                    {/if}
                            </DatagridCell>

                                <DatagridCell title='Exist. Origen' align='right' class='pe-2'>
                                    {#if item.existDest===null}
                                        <small class="text-secondary">No aplica</small>
                                    {:else}
                                        {item.existDest}
                                    {/if}
                                </DatagridCell>                        
                        </DatagridRow>
                        {/each}
                        
                        </svelte:fragment>
                    </Datagrid>

                </div>
            </div>
        </div>


        <!-- PAGINACIÓN -->
        <div class="container mt-3">
            <div class="row">
                <div class="col-12 col-md-6 text-end text-md-start">
                <Infopagination data={dataPagination}/>
                </div>
                <div class="col-12 col-md-6">
                <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
                </div>
            </div>
        </div>

        <div class="container mt-3 mb-3">
            <div class="row">
                <div class="col-12 col-lg-4">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                              <th scope="col" colspan='2' class="text-end text-warning"><i class="bi bi-boxes me-1"></i>EXISTENCIAS</th>
                            </tr>
                        </thead>                        
                        <tbody>
                            <tr>
                                <th class='text-end fw-bold text-primary'>General</th>
                                <td class='text-end text-primary'>{number_format(existencias.existencia,0,'.',',')}</td>
                            </tr>
                            {#each Object.keys($sucursalStore) as  key}

                                <tr>
                                    <th class=' text-end fw-bold' >{$sucursalStore[key]}</th>
                                    <td class='text-end'>{number_format(existencias['existencia'+key],0,'.',',')}</td>
                                </tr>

                            {/each}
                        </tbody>
                    </table>
                    <!-- <div class='mb-0 border-bottom'>
                        <span class='bg-dark text-white px-2 py-1 mb-0 lh-1 text-end d-inline-block' style='width:200px;'><small>Existencia General</small></span>
                        <span class='ps-2 pe-2 mb-0 text-center'><small>12343 Unidad(es)</small></span>
                    </div>
                    {#each Object.keys($sucursalStore) as  key}
                        <div class='mb-1 bg-light border-bottom'
                        class:bg-light={(key % 2)==1}
                        >
                            <span class='bg-secondary border-bottom border-white text-white px-2 py-1 mb-0 lh-1 text-end d-inline-block' style='width:200px;'><small>Existencia {$sucursalStore[key]}</small></span>
                            <span class='ps-2 pe-2 mb-0 text-center'><small>12343 Unidad(es)</small></span>
                        </div>                
                    {/each} -->
                </div>
            </div>
        </div>

    {/if}

    <Helper bind:text={helper}></Helper>
</AnimationContainer>
{/if}